<template>
  <li class="item">
    <a :href="tipo == 'resumo' ? requireUrl() : 'javascript: void(0)'" @click="tipo == 'resumo' ? registraVisualizacao() : $router.push(url)" :target="tipo == 'resumo' ? '_blank' : ''">
      <div class="home-carousel">
        <img class="img-ferramenta" :src="urlImagem(imagem)" />
        <div class="tipo-ferramenta">
          <i class="mdi mdi-cube-scan" v-if="tipo == 'modelo3d'"><p>Modelos 3D</p></i>
          <i class="mdi mdi-text-box" v-else-if="tipo == 'resumo'"><p>Resumos</p></i>
          <i class="mdi mdi-graph" v-else-if="tipo == 'mapa'"><p>Mapas Mentais</p></i>
        </div>
        <div class="ferramenta-topico">
          <p>{{abreviaTitulo(titulo)}}</p>
        </div>
        <div class="ferramenta-breadcrumb">
          <p>{{ disciplina + ' > ' + curso }}</p>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import $ from 'jquery'
import ResumoAPI from '@/api/resumo-api'
export default {
  name: 'CarouselItem',
  props: {
    titulo: String,
    tituloUrl: String,
    url: {
      type: String,
      default: '#'
    },
    textoUrl: String,
    imagem: String,
    cardHover: {
      type: Boolean,
      default: true
    },
    progresso: Number,
    tipo: String,
    disciplina: String,
    curso: String,
    id: Number
  },
  mounted () {
    $('.card-hover').css('opacity', '0')

    $('.item').hover(function () {
      $(this).children('.card-hover').css('opacity', '1')
    }, function () {
      $(this).children('.card-hover').css('opacity', '0')
    })
  },
  methods: {
    requireUrl: function () {
      if (this.url.includes('apostila-web')) {
        return process.env.VUE_APP_BASE_FILES_URL + this.url
      } else {
        return process.env.VUE_APP_BASE_FILES_URL + 'apostila-web/' + this.url
      }
    },
    urlImagem: function (url) {
      if (url.includes('cursos-plataforma')) {
        return process.env.VUE_APP_BASE_FILES_URL + url
      } else {
        return process.env.VUE_APP_BASE_FILES_URL + 'cursos-plataforma/' + url
      }
    },
    abreviaTitulo: function (titulo) {
      if (titulo.length > 40) {
        return titulo.substr(0, 40) + '...'
      }
      return titulo
    },
    async registraVisualizacao () {
      await ResumoAPI.registrarDownload(this.id)
    }
  },
  computed: {
    tipoItem: function () {
      switch (this.tipo) {
        case 'resumo':
          return '<i class="fas fa-file-alt"></i> Resumo'
        case 'modelo3d':
          return '<img src="' + process.env.VUE_APP_BASE_FILES_URL + 'img/heart-branco.png" class="img-fluid modelo3DIcone" /> Modelo 3D'
        case 'mapa':
          return '<i class="fas fa-code-branch"></i> Mapa Mental'
        default:
          return ''
      }
    },
    backgroundItem: function () {
      switch (this.tipo) {
        case 'resumo':
          return 'background-image: url("' + process.env.VUE_APP_BASE_FILES_URL + 'img/carousel-resumo.png' + '");'
        case 'modelo3d':
          return 'background-image: url("' + process.env.VUE_APP_BASE_FILES_URL + 'img/carousel-modelo-3d.png' + '");'
        case 'mapa':
          return 'background-image: url("' + process.env.VUE_APP_BASE_FILES_URL + 'img/carousel-mapa-mental.png' + '");'
        default:
          return ''
      }
    }
  }
}
</script>
